import config from '../../config';
import {
  checkStatus,
} from '../utils/helpers';

// eslint-disable-next-line import/prefer-default-export
export const getMembershipAgreement = (id) => {
  const url = `${config.url}/membership/${id}/agreement`;
  return fetch(url)
    .then(checkStatus);
};



// WEBPACK FOOTER //
// ./src/app/membership/actions.js